/**
 * @generated SignedSource<<d8d30b1c4edc6e16e1af015effc603e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CoverPictureQuery_content$data = {
  readonly coverPictureProperties: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "CoverPictureQuery_content";
};
export type CoverPictureQuery_content$key = {
  readonly " $data"?: CoverPictureQuery_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"CoverPictureQuery_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CoverPictureQuery_content",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "coverPictureProperties",
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "cover-picture-id-draft",
            "cover-picture-id-published"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "concreteType": "Version",
              "kind": "LinkedField",
              "name": "version",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "number"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "da6968c7389a1aa4ff7aa70ff9c18a4e";

export default node;
